<div class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-justify-end" *ngIf="isOpen">
  <!-- Backdrop -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-black/50 dark:tw-bg-black/70"
    (click)="dismiss()"
    [@backdropAnimation]></div>

  <!-- Drawer Content -->
  <div
    class="tw-relative tw-w-full tw-max-w-md tw-bg-white tw-shadow-lg tw-shadow-gray-700 dark:tw-shadow-gray-600 tw-flex tw-flex-col tw-border-l tw-border-gray-200 dark:tw-bg-gray-900 tw-p-4 tw-pb-0"
    [@drawerAnimation]
    role="dialog"
    aria-modal="true">
    <!-- Header -->
    <div
      class="tw-flex tw-justify-between tw-items-center tw-text-gray-800 dark:tw-text-gray-200">
      <div>
        <h2 class="tw-font-semibold tw-text-lg tw-my-1">Download Contacts</h2>
        <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-mt-1">
          {{ ledger.name }} &mdash; {{ scopeLabel
          }}<ng-container *ngIf="contactCount !== null">
            &mdash; <span class="tw-font-semibold">{{ contactCount | number }}</span>
            {{ contactCount === 1 ? 'contact' : 'contacts' }}</ng-container
          >
        </p>
      </div>
      <button mat-icon-button (click)="dismiss()" aria-label="Close drawer">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="tw-flex-1 tw-overflow-y-auto tw-text-gray-800 dark:tw-text-gray-200">
      <!-- File format -->
      <div class="tw-mb-6">
        <label
          class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 tw-mb-3">
          File Format
        </label>
        <mat-radio-group
          class="tw-flex tw-flex-col tw-gap-2"
          [(ngModel)]="selectedFormat"
          aria-label="File format">
          <mat-radio-button
            *ngFor="let format of formats"
            [value]="format.value"
            class="dark:tw-text-gray-200">
            {{ format.label }}
            <span class="tw-block tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
              {{ format.description }}
            </span>
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Destination -->
      <div class="tw-mb-4">
        <label
          class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 tw-mb-3">
          Deliver To
        </label>
        <div *ngIf="loadingDestinations" class="tw-flex tw-items-center tw-gap-2 tw-my-2">
          <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
          <span class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
            Loading destinations...
          </span>
        </div>
        <mat-radio-group
          *ngIf="!loadingDestinations"
          class="tw-flex tw-flex-col tw-gap-2"
          [(ngModel)]="selectedDestinationId"
          aria-label="Deliver to">
          <mat-radio-button [value]="null" class="dark:tw-text-gray-200">
            Direct Download
            <span class="tw-block tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
              The file will download in your browser when it's ready, and is also available later
              from the Downloads page.
            </span>
          </mat-radio-button>
          <mat-radio-button
            *ngFor="let destination of destinations"
            [value]="destination.id"
            class="dark:tw-text-gray-200">
            {{ destination.name }}
            <span
              *ngIf="destinationTypeName(destination)"
              class="tw-block tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">
              {{ destinationTypeName(destination) }}
            </span>
          </mat-radio-button>
        </mat-radio-group>
        <app-alert
          *ngIf="!loadingDestinations && destinations.length === 0"
          [alertType]="alertType.Info"
          alertStyle="compact"
          [hasBorder]="false"
          class="tw-block tw-mt-3">
          <div class="tw-text-sm">
            You can also deliver exports straight to S3, GCS, or Snowflake by setting up a
            destination on the
            <a
              [routerLink]="integrationsLink"
              (click)="dismiss()"
              class="tw-font-semibold tw-underline">
              Integrations page</a
            >.
          </div>
        </app-alert>
      </div>
    </div>

    <!-- Sticky Footer -->
    <div
      class="tw-p-4 tw-bg-white dark:tw-bg-gray-900 tw-flex tw-justify-between tw-items-center tw-shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.2)] dark:tw-shadow-[0_-4px_6px_-1px_rgba(68,68,68,0.3)] tw-relative tw-mt-1 -tw-mx-4">
      <button mat-button (click)="dismiss()" [disabled]="submitting">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        [class.spinner]="submitting"
        [disabled]="submitting || loadingDestinations"
        (click)="startDownload()">
        {{ selectedDestinationId === null ? 'Start Download' : 'Start Delivery' }}
      </button>
    </div>
  </div>
</div>
